const STORAGE_KEY = 'srisai_inventory_favorites'

export function readFavoriteInventoryIds(): Set<string> {
  if (typeof window === 'undefined') return new Set()
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return new Set()
    const arr = JSON.parse(raw) as unknown
    if (!Array.isArray(arr)) return new Set()
    return new Set(arr.filter((x): x is string => typeof x === 'string'))
  } catch {
    return new Set()
  }
}

export function writeFavoriteInventoryIds(ids: Set<string>): void {
  if (typeof window === 'undefined') return
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]))
}

export function toggleFavoriteInventoryId(id: string): boolean {
  const s = readFavoriteInventoryIds()
  const next = !s.has(id)
  if (next) s.add(id)
  else s.delete(id)
  writeFavoriteInventoryIds(s)
  return next
}
